if (!customElements.get('product-recommendations')) {
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();
      this.slider = null;
      this.section_id =  this.getAttribute("data-section-id") || null;
    }

    connectedCallback() {
      this.performRecommendations();
    }

    performRecommendations() {
      const recommendations = this.querySelector(
        '[data-recommendations]'
      );
      if (!recommendations) return;
      fetch(this.dataset.url)
        .then(response => response.text())
        .then(text => {
          const recommendationsHTML = new DOMParser()
            .parseFromString(text, 'text/html')
            .querySelector('[data-recommendations]')?.innerHTML;
          if (!recommendationsHTML) return;
          this.classList.remove('hidden');
          var cartDrawerItemsFull = document.querySelector('.cart-drawer-items__full');
          if(cartDrawerItemsFull) {
            cartDrawerItemsFull.classList.remove('.cart-drawer-items__full');
          }
          recommendations.innerHTML = recommendationsHTML;
          this.initSlider();
          console.log(this.initSlider(),"this");

          // initiate quick cart after fetch
          // to activate trigger button events
          setTimeout(() => {
            if (document.querySelector("quick-cart-drawer")) {
              document.querySelector("quick-cart-drawer").init();
            } else {
              // if quick-cart-drawer does not exists, remove trigger buttons
              this.querySelectorAll(".quick-cart-drawer__trigger").forEach(el => {
                el?.remove();
              })
            }
          }, 500);

        });
    }

        initSlider() {
          this.slider = new Swiper(this, {
            slidesPerView: 4,
            spaceBetween: 16,

            navigation: {
              nextEl: `.swiper-button--next-${this.section_id}`,
              prevEl: `.swiper-button--prev-${this.section_id}`
            },
            breakpoints: { 
              275: { slidesPerView: 1.2,  spaceBetween: 16 },
              500: { slidesPerView: 2,  spaceBetween: 16 },
              750: { slidesPerView: 3,  spaceBetween: 16 },
              990: { slidesPerView: 4,  spaceBetween: 16 }
            } 
          });
        }
    
  }

  customElements.define('product-recommendations', ProductRecommendations);
}
